"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));
var _universalfooter = _interopRequireDefault(require("./universalfooter.proptypes"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FooterContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalFooter__FooterContainer",
  componentId: "sc-1322lvl-0"
})(["background-color:", ";display:flex;flex-wrap:nowrap;flex-direction:", ";justify-content:flex-start;align-items:stretch;min-height:100px;width:100%;overflow:hidden;box-sizing:border-box;border-top:1px solid ", ";", ";"], function (props) {
  return props.theme.backgroundColor[props.background];
}, function (_ref) {
  var viewport = _ref.viewport;
  return viewport === _constants.DEVICE_TYPE.desktop ? 'row' : 'column';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
}, function (_ref3) {
  var viewport = _ref3.viewport;
  return viewport === _constants.DEVICE_TYPE.desktop ? (0, _styledComponents.css)(["padding:40px 80px;"]) : (0, _styledComponents.css)(["padding:20px 30px 75px 25px;"]);
});
var LeftImageContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalFooter__LeftImageContainer",
  componentId: "sc-1322lvl-1"
})(["order:1;cursor:pointer;", ";"], function (_ref4) {
  var theme = _ref4.theme,
    viewport = _ref4.viewport;
  return viewport === _constants.DEVICE_TYPE.desktop ? (0, _styledComponents.css)(["margin-right:", ";"], theme.space.standard) : (0, _styledComponents.css)(["margin-bottom:", ";"], theme.space.XSmall);
});
var RightImageContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalFooter__RightImageContainer",
  componentId: "sc-1322lvl-2"
})(["order:3;cursor:pointer;", ";"], function (_ref5) {
  var theme = _ref5.theme,
    viewport = _ref5.viewport;
  return viewport === _constants.DEVICE_TYPE.desktop ? (0, _styledComponents.css)(["margin-left:", ";"], theme.space.standard) : (0, _styledComponents.css)(["margin-top:", ";"], theme.space.XSmall);
});
var FooterTextContainer = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "UniversalFooter__FooterTextContainer",
  componentId: "sc-1322lvl-3"
})(["flex-grow:1;order:2;font-size:", ";line-height:", ";"], function (_ref6) {
  var fontSize = _ref6.fontSize,
    theme = _ref6.theme;
  return theme.fontSize[fontSize];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight[_constants.DEFAULT_STYLE.DEFAULT_LINE_HEIGHT];
});
var TextWrapper = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "UniversalFooter__TextWrapper",
  componentId: "sc-1322lvl-4"
})(["font-size:", ";line-height:", ";"], function (_ref8) {
  var fontSize = _ref8.fontSize,
    theme = _ref8.theme;
  return theme.fontSize[fontSize];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight[_constants.DEFAULT_STYLE.DEFAULT_LINE_HEIGHT];
});
var UniversalFooter = function UniversalFooter(props) {
  var theme = props.theme,
    accessible = props.accessible,
    data = props.data,
    customProperties = props.customProperties,
    background = props.background,
    color = props.color,
    fontSize = props.fontSize,
    viewport = props.viewport,
    isChinaDomain = props.isChinaDomain,
    idConfig = props.idConfig;
  var components = data.components,
    footerNotes = data.footerNotes;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _ref10 = idConfig || {},
    parentName = _ref10.parentName,
    widgetName = _ref10.widgetName,
    index = _ref10.index;
  var _useState = (0, _react.useState)('universaFooter'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dynamicID = _useState2[0],
    setId = _useState2[1];
  (0, _react.useEffect)(function () {
    var url = 'universalFooter';
    if (parentName) {
      url = "".concat(parentName, "-universalFooter");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  var handleImageClick = function handleImageClick(e, isNewTab, redirectUrl) {
    e.preventDefault();
    if (isNewTab === 'TRUE' || isNewTab === '') {
      window.open(redirectUrl, '_blank');
    } else {
      window.open(redirectUrl, '_self');
    }
  };
  var returnRedirectionUrl = function returnRedirectionUrl(linkList, chinaDomain) {
    if (chinaDomain && linkList.cnUrl && linkList.cnUrl.length > 0) {
      return linkList.cnUrl;
    }
    return linkList.url;
  };
  var constructFooterTextWithLink = function constructFooterTextWithLink(textString, linkListNode, chinaDomain, parentIndex) {
    if (linkListNode) {
      var text = textString;
      var finalSubText = [];
      var linkList = linkListNode.find(function (items) {
        return items.data;
      }).data;
      for (var i = 0; i < linkList.length; i += 1) {
        var splitText = text.split("{".concat(i, "}"));
        var _splitText = (0, _slicedToArray2.default)(splitText, 2),
          leftString = _splitText[0],
          rightString = _splitText[1];
        finalSubText.push(leftString);
        text = rightString;
        var redirectUrl = returnRedirectionUrl(linkList[i], chinaDomain);
        finalSubText.push( /*#__PURE__*/_react.default.createElement(_Link.default, {
          href: redirectUrl,
          size: fontSize,
          accessible: accessible,
          idConfig: {
            parentName: 'universalFooter',
            index: "".concat(parentIndex).concat(i)
          }
        }, linkList[i].label));
      }
      finalSubText.push(text);
      return finalSubText;
    }
    return /*#__PURE__*/_react.default.createElement(TextWrapper, {
      color: color,
      fontSize: fontSize
    }, textString);
  };
  var renderFooterNotes = function renderFooterNotes(fNotes, otherData, chinaDomain) {
    var notes = fNotes && fNotes.find(function (items) {
      return items.data;
    }).data;
    var finalResultingText = [];
    if (notes) {
      for (var i = 0; i < notes.length; i += 1) {
        finalResultingText.push(constructFooterTextWithLink(notes[i].content, otherData[notes[i].id], chinaDomain, i));
        finalResultingText.push( /*#__PURE__*/_react.default.createElement("br", null));
        finalResultingText.push( /*#__PURE__*/_react.default.createElement("br", null));
      }
      finalResultingText.pop();
      return finalResultingText;
    }
    return null;
  };
  var renderFooterComponents = function renderFooterComponents(comp, notes, otherData, chinaDomain) {
    var compList = comp.find(function (item) {
      return item.data;
    }).data;
    return compList.map(function (component) {
      switch (component.type) {
        case _constants.COMP_TYPES.IMAGE:
          return component.direction === _constants.DIRECTION.LEFT ? component.imageUrl && /*#__PURE__*/_react.default.createElement(LeftImageContainer, {
            id: "".concat(dynamicID, "-left"),
            onClick: function onClick(e) {
              return handleImageClick(e, component.newTab, component.redirectUrl);
            },
            key: "leftImageContainer",
            viewport: viewport
          }, /*#__PURE__*/_react.default.createElement(_Image.default, {
            accessible: accessible,
            centerFocus: false,
            height: _constants.DEFAULT_STYLE.DEFAULT_IMAGE_HEIGHT,
            placeHolderBackground: background,
            src: component.imageUrl,
            theme: theme,
            width: _constants.DEFAULT_STYLE.DEFAULT_IMAGE_WIDTH,
            alt: component.altText,
            customProperties: {
              id: 'left-floating-image-footer'
            }
          })) : component.imageUrl && /*#__PURE__*/_react.default.createElement(RightImageContainer, {
            id: "".concat(dynamicID, "-right"),
            onClick: function onClick(e) {
              return handleImageClick(e, component.newTab, component.redirectUrl);
            },
            key: "rightImageContainer",
            viewport: viewport
          }, /*#__PURE__*/_react.default.createElement(_Image.default, {
            accessible: accessible,
            centerFocus: false,
            height: _constants.DEFAULT_STYLE.DEFAULT_IMAGE_HEIGHT,
            placeHolderBackground: background,
            src: component.imageUrl,
            theme: theme,
            width: _constants.DEFAULT_STYLE.DEFAULT_IMAGE_WIDTH,
            alt: component.altText,
            customProperties: {
              id: 'right-floating-image-footer'
            }
          }));
        case _constants.COMP_TYPES.FOOTER_NOTES:
          return /*#__PURE__*/_react.default.createElement(FooterTextContainer, {
            color: color,
            fontSize: fontSize,
            viewport: viewport,
            key: "footerNotes",
            display: "block",
            accessible: accessible
          }, renderFooterNotes(notes, otherData, chinaDomain));
        default:
          return null;
      }
    });
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(FooterContainer, (0, _extends2.default)({
      id: "universal-footer",
      background: background,
      tabIndex: tabIndex,
      color: color,
      fontSize: fontSize,
      viewport: viewport,
      role: "contentinfo"
    }, customProperties), renderFooterComponents(components, footerNotes, data, isChinaDomain)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
UniversalFooter.propTypes = _universalfooter.default.PropTypes;
UniversalFooter.defaultProps = _universalfooter.default.DefaultProps;
var _default = UniversalFooter;
exports.default = _default;